import errorManager from '@/rollbar.js';

const avoidWrongMultiSession = () => {
  const myBusinessUnitId = window.config.business_unit?.id;
  const epersonamBaseUrl = window.config.ePersonamService.ePersonamHost;

  if (!myBusinessUnitId) {
    return;
  }

  broadCast(epersonamBaseUrl, myBusinessUnitId);
};

const broadCast = (epersonamBaseUrl, myBusinessUnitId) => {
  const bc = new BroadcastChannel('ep_channel');
  bc.postMessage({ newBusinessUnitId: myBusinessUnitId });
  bc.onmessage = (event) => {
    const { data } = event;
    if (data.newBusinessUnitId && data.newBusinessUnitId != myBusinessUnitId) {
      window.location.href = `${epersonamBaseUrl}/403.html`;
    }
  };
};

const setObserver = () => {
  avoidWrongMultiSession();
};

const init = () => {
  try {
    setObserver();
  } catch (e) {
    errorManager(e);
  }
};

window.multipleTabSync = {
  init: init,
};
